import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

interface StyledGridProp {
  vertical?: boolean;
}

const StyledGrid = styled(Grid)<StyledGridProp>(({ theme, vertical }) => ({
  '&.rentalWidget': {
    alignItems: 'center',
  },
  '& .RWCheckBox': {
    '& .MuiFormControlLabel-label ': {
      color: theme.palette.common.white,
      fontSize: theme.spacing(2.25),
      fontWeight: 400,
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  '& .RWSearchNowButtonGrid': {
    display: 'flex',
    alignItems: 'center',
  },
  '& .RWArrowIcon': {
    position: 'absolute',
    display: 'flex',
    alignItem: 'center',
    justifyContent: 'center',
    width: theme.typography.pxToRem(28),
    height: theme.typography.pxToRem(28),
    top: '50%',
    transform: 'translateY(-50%)',
    right: theme.typography.pxToRem(-15),
    zIndex: 2,
    background: theme.palette.secondary.light,
    borderRadius: '50%',
    padding: theme.typography.pxToRem(5),
    color: theme.palette.common.white,
    '& svg': {
      width: '100%',
      height: '100%',
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  '& .RWLTwoInputInRow': {
    [theme.breakpoints.up('md')]: {
      border: !vertical && `1px solid ${theme.palette.border[3]}`,
      borderRadius: !vertical && theme.spacing(0.5),
      overflow: !vertical && 'hidden',
      paddingTop: !vertical && 0,
      marginTop: !vertical && theme.spacing(1.5),
    },
  },
  '& .RWInputContainer': {
    borderRight: !vertical && `1px solid ${theme.palette.border[1]}`,
  },
  '& .RWNoticeGrid': {
    flexGrow: 0,
    maxWidth: '100%',
    flexBasis: '100%',
  },
}));

export default StyledGrid;